import routerOptions0 from "/Users/wouter/prjs/wouter/krewebacchus/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.29.7_@babel+core@8.0.7__@babel+plugin-syntax-type_56b9151aa37c35c4ce09a6c9b47bda79/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}